import React, { useState, useEffect } from "react";
import { FormControlLabel, Checkbox } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { API } from "../../../App";

function SponsorsContentRow(props) {
  const [content, setContent] = useState({});
  const subTableRowStyle = { fontSize: "1.7rem", color: "white" };

  const setContentStatus = async (event) => {
    const { id, checked } = event.target;
    fetch(`${API}/api/admin/contents`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage["tk"]}`,
      },
      body: JSON.stringify({ id: content.id, active: event.target.checked }),
    }).then((response) => {
      if (response.status === 200) {
        setContent((x) => ({
          ...x,
          active: checked,
        }));
      }
    });
  };

  useEffect(() => {
    setContent(props.c);
  }, []);

  return (
    <>
      <TableRow key={content.id}>
        {/* Imagen */}
        <TableCell style={subTableRowStyle}>
          <img
            width="80%"
            height="80%"
            src={`/content/${content.path}`}
            srcSet={`/content/${content.path}`}
            alt={`/content/${content.path}`}
            loading="lazy"
          />
        </TableCell>

        {/* Activa? */}
        <TableCell style={subTableRowStyle}>
          <FormControlLabel
            control={
              <Checkbox
                name={content.id}
                id={content.id}
                checked={content.active}
                onChange={setContentStatus}
              />
            }
            label=""
            labelPlacement="end"
          />
        </TableCell>
      </TableRow>
    </>
  );
}

export default SponsorsContentRow;
